<template>

  <div class="card">
    <div class="row">
      <div class="col-md-10">
        <h5>Entidad</h5>
      </div>
      <div class="col-md-2">
        <button class="btn btn-primary btn-raised" type="button" @click="save">Guardar</button>
      </div>
    </div>
    <hr>
    <div v-if="type === 0">
      <div class="row text-center">
        <div class="col-md-12">
          <h5>Datos de la empresa</h5>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3 text-left">
          <label>Razón Social</label>
          <input type="text" class="form-control" v-model="business.name">
        </div>
        <div class="col-md-3 text-left">
          <label>RFC</label>
          <input type="text" class="form-control" v-model="business.rfc">
        </div>
        <div class="col-md-3 text-left">
          <label>Teléfono</label>
          <input type="number" class="form-control" v-model="business.phone">
        </div>
      </div>
    </div>
    <div class="row text-center" v-if="type === 0">
      <div class="col-md-12">
        <h5 style="margin-top: 10px">Apoderado Legal</h5>
      </div>

    </div>
    <div class="row text-center" v-else>
      <div class="col-md-12">
        <h5 style="margin-top: 10px">Datos de contacto</h5>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3 text-left">
        <label>Nombre</label>
        <input type="text" class="form-control" v-model="personal.first_name">
      </div>
      <div class="col-md-3 text-left">
        <label for="tel">Segundo nombre</label>
        <input type="text" class="form-control" v-model="personal.second_name">
      </div>
      <div class="col-md-3 text-left">
        <label for="rfc">Primer apellido</label>
        <input type="text" class="form-control" v-model="personal.last_name_1">
      </div>
      <div class="col-md-3 text-left">
        <label for="rfc">Segundo apellido</label>
        <input type="text" class="form-control" v-model="personal.last_name_2">
      </div>
    </div>
    <div class="row">
      <div class="col-md-3 text-left">
        <label>País de residencia</label>
        <!--input type="text" class="form-control" v-model="personal.residence_country"!-->
        <select class="" name="" class="form-control" v-model.number="personal.residence_country">
          <option value="" disabled selected>Selecciona el país</option>
          <option v-for="c in countries" :value="c.id">{{ c.name }}</option>
        </select>
      </div>
      <div class="col-md-3 text-left" v-if="type === 0">
        <label for="tel">Teléfono personal</label>
        <input type="number" class="form-control" v-model="personal.phone">
      </div>
      <div class="col-md-3 text-left" v-else>
        <label for="tel">Teléfono de contacto</label>
        <input type="number" class="form-control" v-model="personal.phone">
      </div>
      <div class="col-md-3 text-left">
        <label for="rfc">País de Nacionalidad</label>
        <!--input type="text" class="form-control" v-model="personal.citizenship"-->
        <select class="" name="" class="form-control" v-model.number="personal.citizenship">
          <option value="" disabled selected>Selecciona el país</option>
          <option v-for="c in countries" :value="c.id">{{ c.name }}</option>
        </select>
      </div>
      <div class="col-md-3 text-left">
        <label for="rfc">RFC</label>
        <input type="text" class="form-control" v-model="personal.rfc">
      </div>
    </div>
    <div class="row">
      <div class="col-md-3 text-left">
        <label for="rfc">CURP</label>
        <input type="text" class="form-control" v-model="personal.curp">
      </div>
      <!--div class="col-md-3 text-left" v-if="type === 0">
        <label for="rfc">Teléfono de contacto</label>
        <input type="text" class="form-control" v-model="business.phone">
      </div>
      <div class="col-md-3 text-left" v-else>
        <label for="tel">Teléfono de contacto</label>
        <input type="text" class="form-control" v-model="personal.phone">
      </div!-->
    </div>
    <div class="row">
      <div class="col-md-6">
        <label>ID Oficial - Frente
          <a-secure :href="StorageURL + '/storage/private/user/'+ usuario + '/' + personal.official_id_front_file" target="_blank" download><em class="material-icons">file_download</em></a-secure>
          <a-secure :href="StorageURL + '/storage/private/user/'+ usuario + '/' + personal.official_id_front_file" target="_blank"><em class="material-icons">open_in_new</em></a-secure></label>
        <formdata-file-upload
          :popup="true"
          field="official_id_front_file"
          title="ID Oficial Frontal"
          :path="'/storage/private/user/' + usuario + '/'"
          :src="personal.official_id_front_file"
          :userId="usuario"
          @uploaded="function(a){personal.official_id_front_file = a}"
          ></formdata-file-upload>
        <!--embed :src="StorageURL + '/storage/private/user/'+ usuario + '/' + personal.official_id_front_file" type="application/pdf" width="100%" height="300px" v-if="isPDF(personal.official_id_front_file)"/>
        <div class="file" v-else>
          <img :src="StorageURL + '/storage/private/user/'+ usuario + '/' + personal.official_id_front_file" alt="No actualizado">
        </div!-->
      </div>
      <div class="col-md-6">
        <label>ID Oficial - Posterior
          <a-secure :href="StorageURL + '/storage/private/user/'+ usuario + '/' + personal.official_id_back_file" target="_blank" download><em class="material-icons">file_download</em></a-secure>
          <a-secure :href="StorageURL + '/storage/private/user/'+ usuario + '/' + personal.official_id_back_file" target="_blank"><em class="material-icons">open_in_new</em></a-secure></label>
        <formdata-file-upload
          :popup="true"
          field="official_id_back_file"
          title="ID Oficial Posterior"
          :path="'/storage/private/user/' + usuario + '/'"
          :src="personal.official_id_back_file"
          :userId="usuario"
          @uploaded="function(a){personal.official_id_back_file = a}"
          ></formdata-file-upload>
        <!--embed :src="StorageURL + '/storage/private/user/'+ usuario + '/' + personal.official_id_back_file" type="application/pdf" width="100%" height="300px" v-if="isPDF(personal.official_id_back_file)"/>
        <div class="file" v-else>
          <img :src="StorageURL + '/storage/private/user/'+ usuario + '/' + personal.official_id_back_file" alt="No actualizado">
        </div!-->
      </div>
      <div class="col-md-6" v-if="type === 0">
        <label>Constancia Fiscal
          <a-secure :href="StorageURL + '/storage/private/user/'+ usuario + '/' + business.fiscal_record_file" target="_blank" download><em class="material-icons">file_download</em></a-secure>
          <a-secure :href="StorageURL + '/storage/private/user/'+ usuario + '/' + business.fiscal_record_file" target="_blank"><em class="material-icons">open_in_new</em></a-secure></label>
        <formdata-file-upload
          :popup="true"
            field="fiscal_record_file"
            title="Constancia fiscal"
            :path="'/storage/private/user/' + usuario + '/'"
            :src="business.fiscal_record_file"
            :userId="usuario"
            @uploaded="function(a){business.fiscal_record_file = a}"
            ></formdata-file-upload>
        <!--embed :src="StorageURL + '/storage/private/user/'+ usuario + '/' + business.fiscal_record_file" type="application/pdf" width="100%" height="300px" v-if="isPDF(business.fiscal_record_file)"/>
        <div class="file" v-else>
          <img :src="StorageURL + '/storage/private/user/'+ usuario + '/' + business.fiscal_record_file" alt="No actualizado">
        </div!-->
      </div>
      <div class="col-md-6" v-if="type === 0">
        <label>Acta Constitutiva
          <a-secure :href="StorageURL + '/storage/private/user/'+ usuario + '/' + business.constitutive_act_file " target="_blank" download><em class="material-icons">file_download</em></a-secure>
          <a-secure :href="StorageURL + '/storage/private/user/'+ usuario + '/' + business.constitutive_act_file " target="_blank"><em class="material-icons">open_in_new</em></a-secure></label>
        <formdata-file-upload
          :popup="true"
          field="constitutive_act_file"
          title="Acta constitutiva"
          :path="'/storage/private/user/' + usuario + '/'"
          :src="business.constitutive_act_file"
          :userId="usuario"
          @uploaded="function(a){business.constitutive_act_file = a}"
          ></formdata-file-upload>
        <!--embed :src="StorageURL + '/storage/private/user/'+ usuario + '/' + business.constitutive_act_file " type="application/pdf" width="100%" height="300px" v-if="isPDF(business.constitutive_act_file )"/>
        <div class="file" v-else>
          <img :src="StorageURL + '/storage/private/user/'+ usuario + '/' + business.constitutive_act_file " alt="No actualizado">
        </div!-->
      </div>
      <div class="col-md-6" v-if="type === 1">
        <label>Constancia Fiscal
          <a-secure :href="StorageURL + '/storage/private/user/'+ usuario + '/' + personal.fiscal_record_file" target="_blank" download><em class="material-icons">file_download</em></a-secure>
          <a-secure :href="StorageURL + '/storage/private/user/'+ usuario + '/' + personal.fiscal_record_file" target="_blank"><em class="material-icons">open_in_new</em></a-secure></label>
        <formdata-file-upload
          :popup="true"
            field="fiscal_record_file"
            title="Constancia fiscal"
            :path="'/storage/private/user/' + usuario + '/'"
            :src="personal.fiscal_record_file"
            :userId="usuario"
            @uploaded="function(a){personal.fiscal_record_file = a}"
            ></formdata-file-upload>
        <!--embed :src="StorageURL + '/storage/private/user/'+ usuario + '/' + personal.fiscal_record_file" type="application/pdf" width="100%" height="300px" v-if="isPDF(personal.fiscal_record_file)"/>
        <div class="file" v-else>
          <img :src="StorageURL + '/storage/private/user/'+ usuario + '/' + personal.fiscal_record_file" alt="No actualizado">
        </div!-->
      </div>
    </div>
    <div class="row text-center">
      <div class="col-md-12">
        <h5>Dirección</h5>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3 text-left">
        <label>Calle</label>
        <input type="text" class="form-control" v-model="address.street">
      </div>
      <div class="col-md-3 text-left">
        <label for="tel">No. Exterior</label>
        <input type="text" class="form-control" v-model="address.ext_number">
      </div>
      <div class="col-md-3 text-left">
        <label>No. Interior</label>
        <input type="text" class="form-control" v-model="address.int_number">
      </div>
      <div class="col-md-3 text-left">
        <label for="tel">Colonia</label>
        <input type="text" class="form-control" v-model="address.neighborhood">
      </div>
    </div>
    <div class="row">
      <div class="col-md-3 text-left">
        <label>País</label>
        <select class="" name="" class="form-control" v-model.number="address.country_id" disabled>
          <option value="" disabled selected>Selecciona el país</option>
          <option v-for="c in countries" :value="c.id">{{ c.name }}</option>
        </select>
      </div>
      <div class="col-md-3 text-left">
        <label for="tel">Estado</label>
        <select class="form-control" placeholder="Selecciona el Estado" @change="getCities" v-model="address.state">
            <option v-for="ste in states" :value="ste.id">{{ ste.name }}</option>
        </select>
      </div>
      <div class="col-md-3 text-left">
        <label>Municipio/Ciudad</label>
        <select class="form-control" v-model.number="address.city_id" placeholder="Selecciona el Estado">
          <option value="" disabled selected>Selecciona la ciudad</option>
          <option v-for="ct in cities" :value="ct.id">{{ ct.name }}</option>
        </select>
      </div>
      <div class="col-md-3 text-left">
        <label for="tel">Código postal</label>
        <input type="text" class="form-control" v-model="address.zipcode">
      </div>
    </div>
    <br>
  </div>

</template>

<script lang="js">
  import ASecure from "@components/utils/aSecure";
  let Vue = require('vue');
  let FormDataFileUpload = require('../formdata-file-upload').default;
  export default  {
    name: 'supplier-personal',
    props: ['id_supplier', 'usuario'],
    components: {
      ASecure,
      'formdata-file-upload': FormDataFileUpload,
    },
    mounted() {
      axios.get( '/api/supplier/entity/' + this.id_supplier).then(response => {
        this.business = response.data.business
        this.personal = response.data.personal
        this.address = response.data.address
        this.type = response.data.type
        this.getStates()
      })
      axios.get( '/api/countries').then(response => {
        this.countries = response.data
      })
    },
    data() {
      return {
        type: '',
        business: {},
        personal: {},
        address: {},
        cities:[],
        states: [],
        countries: []
      }
    },
    methods: {
      save(){
        //console.log('proximamente...')
        Vue.toasted.show('Guardando...', { position: 'bottom-center', closeOnSwipe: false });
        var data = {
          personal: this.personal,
          business: this.business,
          address: this.address
        }
        axios.post('/api/supplier/entity/' + this.id_supplier, data).then(response => {
          Vue.toasted.clear()
          Vue.toasted.show('Información guardada!!', { position: 'bottom-center', type:'success', closeOnSwipe: false, duration: 2000 })
        }).catch(error => {
          Vue.toasted.clear()
          Vue.toasted.show('Parece que ha ocurrido un error, inténtalo de nuevo', { position: 'bottom-center', type:'error', closeOnSwipe: true})
        })
      },
      getStates(){
        axios.get( '/api/states').then(response => {
          this.states = response.data
          this.getCities()
        })
      },
      getCities(){
        axios.get( '/api/cities/' + this.address.state).then(response => {
          this.cities = response.data
        })
      },
      isPDF(filename){
        if(filename != null){
          var datas = filename.split('.')
          var data = datas[datas.length-1]
          if(data.toUpperCase() == 'PDF'){
            return true
          }else{
            return false
          }
        }
      }
    },
    computed: {

    }
}
</script>

<style scoped lang="scss">
  .supplier-personal {

  }

  .header-row{
    margin-top: 10px;
  }
  .col-md-6{
    margin-top: 10px;
  }
  .row{
    margin-top: 15px;
  }
  .card{
    padding: 0 10px;
  }

  .file{
    min-height: 300px;
    max-height: 300px;
    overflow: hidden;
  }
  .file:hover{
    overflow: auto;
  }
  .file img{
    width: 100%
  }
</style>
